// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-group-vertical .btn+.btn[data-v-20ee1c84]{margin-left:0 !important}
`, "",{"version":3,"sources":["webpack://./src/components/button-group/ButtonGroup.vue"],"names":[],"mappings":"AAEI,+CACI,wBAAyB","sourcesContent":["\n    // TODO: This should be fixed in Shards.\n    .btn-group-vertical .btn + .btn {\n        margin-left: 0 !important;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
